<template>
  <div>
    <vxe-table :data="tableData">
      <vxe-table-column field="branchName" title="承运主体" />
      <vxe-table-column field="taxPoint" title="服务费率(%)" />
    </vxe-table>
  </div>
</template>
<script>
import { statisticsList } from "@/api/shipment";
export default {
  props: {
    branchInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableData: [
        {
          brachName: "34",
          tax: "12"
        },
        {
          brachName: "34",
          tax: "12"
        }
      ]
    };
  },
  watch: {
    branchInfo: {
      handler(newVal) {
        if (newVal) {
          this.getStatisticsList(newVal.partyCode);
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    getStatisticsList(partyCode) {
      statisticsList({ partyCode }).then(res => {
        if (res.status === 0) {
          this.tableData = res.data;
        }
      });
    }
  }
};
</script>
